import request from '../../../../request/request';

const assignPolicies = data => {
  const { userName, policies } = data;
  return request({
    url: `/webapi/user/${userName}/assign-policies`,
    method: 'post',
    data: { policies }
  });
};

// eslint-disable-next-line import/prefer-default-export
export { assignPolicies };
